export const peopleSelector = state => state.people;
